import type { ErrorEvent } from "@sentry/browser";

const EXTENSION_URL_PATTERN =
  /^(?:chrome-extension|moz-extension|safari-web-extension):\/\//;
const USERPILOT_SDK_HOST = "js.userpilot.io";

/**
 * Returns true for Sentry events that are not actionable: errors from browser
 * extensions, and errors thrown from inside Userpilot's SDK.
 */
export function shouldDropSentryEvent(event: ErrorEvent) {
  const values = event.exception?.values ?? [];
  const frames = values.flatMap((value) => value.stacktrace?.frames ?? []);
  const isExtensionError = frames.some(
    (frame) => !!frame.filename && EXTENSION_URL_PATTERN.test(frame.filename)
  );
  if (isExtensionError) {
    return true;
  }

  const thrownFromFilename = values
    .at(-1)
    ?.stacktrace?.frames?.at(-1)?.filename;
  return !!thrownFromFilename && isUserpilotSdkUrl(thrownFromFilename);
}

function isUserpilotSdkUrl(filename: string) {
  try {
    return new URL(filename).hostname === USERPILOT_SDK_HOST;
  } catch (_) {
    return false;
  }
}
